module.exports = __webpack_public_path__ + "img/categorie-crustaces-famille-boutrais.524a0522.webp";